import LocationsList from './_LocationsList';

export default LocationsList;
